import AssetComponent from './AssetComponent.gql';

export default AssetComponent;
